import { message } from "antd";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./clientEscalationView.css";
import { useLocation } from "react-router-dom";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import secureLocalStorage from "react-secure-storage";
import ClientEscalationDetails from "./clientEscalationDetails";
import CustomLoader from "../../common/customLoader";
import TopContainerHeader from "../../../components/molecules/TopComponentHeader";
import { fetchClientEscalationDetailThunk } from "../../../store/thunks/clientEscalationsThunk";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const ClientEscalationView = () => {
  const dispatch = useDispatch();
  const { detail, loading } = useSelector(
    (state) => state.qmsClientEscalations,
  );

  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const location = useLocation();
  const navigate = useNavigate();

  const { id } = useParams();

  const prevData = location?.state;

  useEffect(() => {
    if (!id) return;

    dispatch(fetchClientEscalationDetailThunk({ id }))
      .unwrap()
      .then((response) => {
        setGlobalState((prev) => ({
          ...prev,
          eDetails: response,
          eListingPrevData: prevData,
        }));
      })
      .catch((err) => {
        message.error(err?.message || "Failed to fetch escalation details");
      });
  }, [id]);

  useEffect(() => {
    if (!window.performance) return;

    const entries = performance.getEntriesByType("navigation");

    if (
      secureLocalStorage.getItem("clickedLink") !==
      "clientEscalationDetailLinkClick"
    ) {
      if (entries.length > 0 && entries[0].type === "reload") {
        secureLocalStorage.setItem(
          "clickedLink",
          "clientEscalationDetailLinkVisit",
        );
      }
    }
  }, []);

  return (
    <div className="all-content">
      <CustomLoader showLoader={loading} />
      <TopContainerHeader
        sectionTitle="Client Escalation"
        sectionDescription={`${globalState?.eDetails?.transactionId} ${globalState?.eDetails?.client}`}
        hasSectionButton={false}
        sectionButtons={[]}
        hasFilter={false}
        buttonTitle="Add New"
      />
      <ClientEscalationDetails />
    </div>
  );
};
export default ClientEscalationView;
